const SearchBadgeGroup = ({ badges }) => {
  return (
    <div className="flex flex-wrap gap-[10px]">
      {badges.map((badge, index) => (
        <span
          key={index}
          className="flex h-5 min-w-0 items-center justify-center overflow-hidden rounded-lg bg-[rgba(255,255,255,0.1)] px-2 text-center text-white text-xs leading-4"
        >
          {badge}
        </span>
      ))}
    </div>
  );
};

export default SearchBadgeGroup;
